import { useTranslation } from 'react-i18next';

interface LoadingStateProps {
    message?: string;
    className?: string;
}

export const LoadingState = ({
    message,
    className = 'h-64',
}: LoadingStateProps) => {
    const { t } = useTranslation('codPayouts');
    const displayMessage = message || t('loading.default');

    return (
        <div
            className={`flex items-center justify-center transition-colors ${className}`}
        >
            <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
                <p className="text-muted-foreground">{displayMessage}</p>
            </div>
        </div>
    );
};
